import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 * @summary Google, Adobe click for Read More link inside additional Protections modal on vdp
 */
export async function inventoryProtectionReadMoreClick(metadata, option) {

    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { inventoryId, title } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    const element = `vdp_${data?.listingType.toLowerCase()}`;
    const eventData = {
        vehicle: { ...vehicleData },
    };

    const cmp = `text-link::read-more::${_kebabCase(title)}`;

    Google.sendClickEvent({
        eventElement: element,
        eventResult: cmp,
        eventData,
    }, option);

    return { cmp, element, title };

}
